var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-settings"},[_c('base-title',{staticClass:"sticky-title",attrs:{"title":"Settings"}},[_c('div',{attrs:{"slot":"action"},slot:"action"})]),_c('course-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }